import React, { PureComponent } from 'react'
import cn from 'classnames'
import { isEmpty } from 'lodash'
import { Field, FieldArray } from 'redux-form'
import { Paper, Grid, Button, CircularProgress } from '@material-ui/core'

import { Input, PassengerFields, CitiesFields, SelectInput, PlaceField } from 'components'

export class BookFormBase extends PureComponent {
  componentDidUpdate(prevProps) {
    const { routeId, shownRoutes, getCitiesRoutePrice, getDepartureTime,
      citiesPrice, formValueChange, departureTime } = this.props

    if (isEmpty(departureTime) || prevProps.shownRoutes !== this.props.shownRoutes) {
      getDepartureTime()
    }

    if (!routeId && prevProps.shownRoutes.length !== shownRoutes) {
      getCitiesRoutePrice()
    }

    if (citiesPrice) {
      formValueChange('book', 'price', citiesPrice.price)
    }
  }

  onSystemChange = e => {
    const { formValueChange, sources, initialValues: { limit } } = this.props

    const systemId = e.target.value

    if (systemId) {
      const source = sources.find(({ id }) => systemId === id)

      formValueChange('book', 'limit', source.limit - (source.booked || 0))
    } else {
      formValueChange('book', 'limit', limit)
    }
  }

  renderSources = ({ id, label }) => <option value={id} key={id}>{label}</option>

  render() {
    const { classes, handleSubmit, valid, routeId, sources, isLimitedDispatcher,
      addBooking, isPartner, isLoading, changeRouteLimit, isDisabled } = this.props

    const validBook = valid && routeId

    return (
      <Paper className={cn(classes.container, isDisabled && classes.disabled)}>
        <Grid
          container
          spacing={16}
          onSubmit={handleSubmit(addBooking)}
          component='form'
        >
          <Grid
            item
            container
            spacing={16}
          >
            <CitiesFields />
          </Grid>

          <Grid
            item
            container
            spacing={16}
          >
            <FieldArray name='addPax' component={PassengerFields} />
          </Grid>

          <Grid
            item
            container
            spacing={16}
            alignItems='center'
          >
            <Grid item xs={isPartner || isLimitedDispatcher ? 6 : 4}>
              <Field
                fullWidth
                name='note'
                label='Відмітка'
                margin='normal'
                component={Input}
              />
            </Grid>

            {!isPartner && !isLimitedDispatcher && (
              <Grid item xs={2}>
                <Field
                  fullWidth
                  name='system'
                  label='Система'
                  margin='normal'
                  onChange={this.onSystemChange}
                  component={SelectInput}
                >
                  <option value='' />
                  {sources.map(this.renderSources)}
                </Field>
              </Grid>
            )}

            <Grid item xs>
              <PlaceField />
            </Grid>

            <Grid item xs>
              <Field
                fullWidth
                name='limit'
                type='number'
                label='Ліміт'
                margin='normal'
                onBlur={changeRouteLimit}
                disabled={isPartner || isLimitedDispatcher || !routeId}
                component={Input}
                inputProps={{
                  min: 0
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid
              xs
              item
              className={classes.bookButton}
            >
              <Button
                type='submit'
                color='primary'
                variant='contained'
                disabled={!validBook || isLoading}
              >
                Забронювати
                {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
              </Button>
            </Grid>
          </Grid>

        </Grid>
      </Paper>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/BookForm/BookForm.js